module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-honda.6b9d9aaa.png";